import EfIcon from '@elem/ui/ef-icon';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.OtherC');
    return (
        <div className={`ef-container ${styles.TheComp}`}>
            <div className="OtherC-list-title title-2">{t('list_b_title')}</div>
            <div className="OtherC-list compb">
                <EfIcon className="OtherC-list-icon" pc="https://websiteoss.ecoflow.com/upload/image/1725590106418/Winnebago.png" />
                <EfIcon className="OtherC-list-icon" pc="https://websiteoss.ecoflow.com/upload/image/1725590106008/REI.png" />
                <EfIcon className="OtherC-list-icon" pc="https://websiteoss.ecoflow.com/upload/image/1725590105792/West%20Marine.png" />
                <EfIcon className="OtherC-list-icon" pc="https://websiteoss.ecoflow.com/upload/image/1725589964155/Fendt.png" />
                <EfIcon className="OtherC-list-icon" pc="https://websiteoss.ecoflow.com/upload/image/1725589963742/Campervan.png" />
            </div>
        </div>
    );
}
